








import { defineComponent } from '@vue/composition-api';
import { IStoryblokPage, IPageContent } from '~/types/storyblok';
import { CMSService } from '~/services/storyBlok/cmsService';
import { affirmScript } from '~/configuration/metaData';

export default defineComponent({
  name: 'AccessoryAndBundlePages',
  head() {
    const res = this.storyResp as IPageContent;

    return {
      title: res.metaInfo?.title,
      meta: [
        { hid: 'description', name: 'description', content: res.metaInfo?.description },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: res.metaInfo?.title },
        { hid: 'og:description', property: 'og:description', content: res.metaInfo?.description },
        { hid: 'og:image', property: 'og:image', content: getImageUrl(res) },
        { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:description', name: 'twitter:description', content: res.metaInfo?.description },
        { hid: 'twitter:title', name: 'twitter:title', content: res.metaInfo?.title },
        { hid: 'twitter:image', name: 'twitter:image', content: getImageUrl(res) },
        { hid: 'twitter:site', name: 'twitter:site', content: '@joinfightcamp' },
        { hid: 'twitter:creator', name: 'twitter:creator', content: '@joinfightcamp' },
      ],
      script: [affirmScript],
    };
  },
  mounted() {
    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  },
  async asyncData({
    $storyapi,
    error,
    route,
    payload,
  }): Promise< {storyRespId: number | null, storyResp: IPageContent | null}> {
    // TODO need to figure out why payload is undefined
    if (payload) {
      return {
        storyRespId: payload?.id,
        storyResp: payload?.content,
      };
    }

    let storyResp = null;
    let storyRespId = null;

    try {
      const storyBlok = new CMSService({ cmsService: $storyapi });
      const resp = await storyBlok.get(['shop', 'products', route.params?.slug ?? ''].join('/'), { resolve_relations: 'RelatedProducts.products' });

      const story = resp?.data?.story as IStoryblokPage;
      storyRespId = story?.id;
      storyResp = story?.content;
    } catch (err: any) {
      error({ message: err.message });
    }

    return {
      storyResp,
      storyRespId,
    };
  },
});

function getImageUrl(res) {
  return res.body?.[0]?.container?.[0]?.contentContainer?.[0]?.mediaGrid?.[0]?.Image?.filename ?? '';
}
